import React, { Component } from "react";
import styles from "./routeControlPoints.module.scss";
import { withControlPoints } from "../../../shared/containers/containerControlPoints";

class RouteControlPointsList extends Component {
  render() {
    const { routeControlPoints, onClickHandler, selectedControlPointId } = this.props;

    return routeControlPoints.map((controlPoint) => {
      return (
        <div
          className={selectedControlPointId !== controlPoint.id ? styles.routeControlPointListItem : styles.routeControlPointListItemSelect}
          key={controlPoint.id}
          onClick={(e) => {
            onClickHandler(controlPoint.id);
          }}
        >
          <span>{controlPoint.number}. </span>
          <span>{controlPoint.title}</span>
        </div>
      );
    });
  }
}

export default withControlPoints(React.memo(RouteControlPointsList));
